export default {
    computed: {
        token: function () {
            return this.$root.$children[0].$data.apiClient.token;
        },
        packageId: function () {
            return this.$root.$children[0].$data.apiClient.packageId;
        },
        baseUrl: function () {
            return this.$root.$children[0].$data.apiClient.baseUrl;
        }
    }
}